import { render, staticRenderFns } from "./MediaPopup.vue?vue&type=template&id=4508796e&scoped=true&"
import script from "./MediaPopup.vue?vue&type=script&lang=js&"
export * from "./MediaPopup.vue?vue&type=script&lang=js&"
import style0 from "./MediaPopup.vue?vue&type=style&index=0&id=4508796e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4508796e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VDialog,VIcon,VImg})
